import React from 'react';
import { Flex, IconV2, TextV2 } from '@withjoy/joykit';
import { Warning } from '@withjoy/joykit/icons';

type WarningNoticeProps = React.ComponentProps<typeof Flex>;

export const WarningNotice: React.FC<WarningNoticeProps> = ({ children, ...flexProps }) => {
  return (
    <Flex
      rowGap={3}
      justifyContent="center"
      padding={5}
      borderRadius={3}
      borderWidth="1px"
      borderStyle="solid"
      borderColor="warning3"
      backgroundColor="warning1"
      {...flexProps}
    >
      <IconV2
        color="warning6"
        marginRight={2}
      >
        <Warning />
      </IconV2>
      <TextV2 typographyVariant="body1">{children}</TextV2>
    </Flex>
  );
};
